import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["source", "feedback"];

  copy() {
    const text = this.sourceTarget.value;
    if (!text) {
      this.showFeedback("Nothing to copy.");
      return;
    }

    navigator.clipboard.writeText(text).then(
      () => this.showFeedback("Copied to clipboard."),
      () => this.showFeedback("Copy failed — select the text and copy manually.")
    );
  }

  showFeedback(message) {
    if (!this.hasFeedbackTarget) {
      return;
    }
    this.feedbackTarget.textContent = message;
  }
}
